// Developer: Ankit Gupta
interface LogoProps {
  /** Collapsed sidebar shows the mark only; expanded shows mark + wordmark. */
  collapsed?: boolean;
  size?: number;
  darkTheme?: boolean;
}

/**
 * DataPilot brand mark - a paper-plane (pilot / navigation) in a rounded
 * gradient badge, with the "DataPilot" wordmark. Inline SVG so it stays crisp
 * at any size and adapts to the sidebar collapse/expand.
 */
export default function Logo({ collapsed = false, size = 30, darkTheme = false }: LogoProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, overflow: 'hidden' }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
        aria-label="DataPilot"
      >
        <defs>
          <linearGradient id="dp-logo-grad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#ef4444" />
            <stop offset="1" stopColor="#dc2626" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="9" fill="url(#dp-logo-grad)" />
        {/* paper plane */}
        <g transform="translate(16 16) scale(0.88) translate(-16.5 -14.8)">
          <path d="M27.5 5.5 L4.5 13.2 L12.8 16.7 Z" fill="#ffffff" />
          <path d="M27.5 5.5 L12.8 16.7 L16.4 25.6 Z" fill="#fee2e2" />
          <path d="M27.5 5.5 L12.8 16.7 L14.4 20.7 Z" fill="#fef2f2" />
        </g>
      </svg>
      {!collapsed && (
        <span
          style={{
            fontFamily: 'var(--dp-font-display)',
            fontSize: 18,
            fontWeight: 700,
            letterSpacing: 0.2,
            whiteSpace: 'nowrap',
            color: darkTheme ? '#ffffff' : 'var(--dp-ink)',
          }}
        >
          Data<span style={{ color: darkTheme ? '#f87171' : 'var(--dp-accent)' }}>Pilot</span>
        </span>
      )}
    </div>
  );
}
